import ProductList from "./components/ProductList";
import { useNavigate } from "react-router-dom";
import Meta from "./components/Meta";
import { useCallback, useEffect, useState } from "react";

const Main = () => {
  const [isProductSectionUnavailable, setIsProductSectionUnavailable] =
    useState(false);
  const handleProductError = useCallback(
    () => setIsProductSectionUnavailable(true),
    [],
  );
  const ProductListProps = {
    limit: 3,
    currentPage: 1,
    type: "FIX",
  };

  const ProductListSwiperProps = {
    limit: 10,
    currentPage: 1,
    type: "SWIPER",
  };

  const navigate = useNavigate(); // navigate 훅을 사용하여 페이지 이동

  const goBlueberryPage = (_event: any) => {
    navigate("/blueberry");
  };

  const goCaringPage = (_event: any) => {
    navigate("/caring");
  };

  const goShopPage = (_event: any) => {
    _event.preventDefault();
    navigate("/shop");
  };

  useEffect(() => {
    const redirectPath = sessionStorage.getItem("redirectPath");
    if (redirectPath) {
      sessionStorage.removeItem("redirectPath");
      navigate(redirectPath); // 실제로 라우터가 처리하게 함
    }
  }, [navigate]);

  return (
    <>
      <Meta
        title="제때팜 | 세종 블루베리 농장·수확 체험 | 제때협동조합"
        description="제때팜 제때협동조합은 세종에서 블루베리 농장 수확 체험과 농촌 돌봄 농장을 운영합니다."
      />
      <main className="home">
        <div className="top-wrap">
          <div className="main-text-wrap">
            <div>
              <h1 className="title">
                제때팜 | 세종 블루베리 농장과
                <br className="mw-tag hide" /> 수확 체험
              </h1>
              <p>
                제때 따서 제때 먹는,
                <br className="mw-tag hide" /> 자연의 축복이 담긴 건강한
                선택으로
                <br className="mw-tag hide" /> 일상을 빛나게 해보세요.
              </p>
              <button onClick={goBlueberryPage}>더 알아보기</button>
            </div>
          </div>
        </div>
        <div className="about-wrap">
          <div className="contents">
            <div>
              <p className="green-color-title">About us</p>
              <p>
                탐스러운 블루베리와
                <br className="mw-tag hide" /> 행복한 미소가 만나는 그 순간을
                <br className="mw-tag hide" /> 아이들에게 선물하세요.
              </p>
            </div>
            <div className="box-wrap">
              <div onClick={goBlueberryPage} className="blueberry-wrap">
                <p className="title">블루베리 농장</p>
                <p>
                  <button>자세히 보기</button>
                </p>
              </div>
              <div onClick={goCaringPage} className="caring-wrap">
                <p className="title">농촌 돌봄 농장</p>
                <p>
                  <button>자세히 보기</button>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="product-wrap">
          {!isProductSectionUnavailable && (
            <div>
              <p className="sub-title">제때 쇼핑몰</p>
              <p>
                기름 없이 열과 압력으로 구워 만들어
                <br className="mw-tag hide" /> 바삭하고 고소해요
              </p>
              <button onClick={goShopPage}>자세히 보기</button>
            </div>
          )}
          {isProductSectionUnavailable ? (
            <section
              className="product-store-cta"
              aria-label="제때팜 공식 쇼핑몰"
            >
              <p className="product-store-cta__eyebrow">JETTE FARM STORE</p>
              <h2>제때팜의 건강한 먹거리</h2>
              <p>
                판매 중인 상품과 재고, 가격은 공식 네이버 스마트스토어에서 가장
                정확하게 확인할 수 있습니다.
              </p>
              <a
                href="https://smartstore.naver.com/cct7007"
                target="_blank"
                rel="noreferrer"
              >
                공식 스마트스토어에서 상품 보기
              </a>
            </section>
          ) : (
            <>
              <div className="product-wrap-list pc-tag hide">
                <ProductList
                  {...ProductListProps}
                  onError={handleProductError}
                />
              </div>
              <div className="product-wrap-list mw-tag hide">
                <ProductList
                  {...ProductListSwiperProps}
                  onError={handleProductError}
                />
              </div>
            </>
          )}
        </div>
      </main>
    </>
  );
};

export default Main;
